module.exports = __webpack_public_path__ + "img/step2-c.dff1d252.png";